import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IGetAllDiarioObrasImagensUseCase } from "../../../presentation/useCases/read/get_all_diario_obras_imagens_use_case";
import { DiarioObrasImagensFilter } from "../../models/diario_obras_imagens_filter";
import { DiarioObrasImagem } from "../../models/diario_obras_imagens_lista";
import { IDiarioObraRepository } from "../../repositories/diario_obra_repository";


// GetAllDiarioObrasImagensServicoUseCase


export class GetAllDiarioObrasImagensServicoUseCase
  extends BasePaginatedUseCase<DiarioObrasImagem>
  implements IGetAllDiarioObrasImagensUseCase {
  constructor(private readonly repository: IDiarioObraRepository) {
    super();
  }

  async getAllListagemDiariosObrasImagens(
    filter: DiarioObrasImagensFilter,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    if (filter.IdDiarioObras === undefined) throw new Error('Id de diario de obra inválido!');

    const response = await this.repository
      .getAllListagemDiariosObrasImagens(
        filter,
        page,
        rowsPerPage,
      );
    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }
}
